import {take} from 'redux-saga/effects';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import creditGeocodedLocation from '../../service-cases/sagas/creditGeocodedLocation';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as saaActionTypes from '../saaActionTypes';

/**
 * Update SAA member location flow
 */
const updateSAAMemberLocationFlow = function* updateSAAMemberLocationFlow() {
    while (true) {
        const {payload} = yield take(saaActionTypes.SUBMIT_SAA_MEMBER_LOCATION_FORM);
        const {serviceAssignmentLineNo, serviceAssignmentData, serviceCaseId} = payload;

        yield* updateServiceAssignment({
            caller: saaActionTypes.SUBMIT_SAA_MEMBER_LOCATION_FORM,
            assignmentType: efServiceAssignmentTypes.ACCOMMODATION,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        // credit stored location
        yield* creditGeocodedLocation({location: serviceAssignmentData.memberLocation});
    }
};

export default updateSAAMemberLocationFlow;
